var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.583984 0.666504V3.4165H5.62565V14.4165H8.37565V3.4165H13.4173V0.666504H0.583984Z","fill":"#8C8C8C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }